<template>
  <div class="contact-card py-12">
    <!-- Lines -->
    <brand-lines v-if="element" class="contact-card__lines" position="center-right" stroke-width="1.5" :parent-element="element" :stroke-width="hasMobile ? '0.4' : '0.2'"  />
    <!-- Container -->
    <v-container class="contact-card__container py-12">
      <!-- Wrap -->
      <v-card class="contact-card__wrap" flat>
        <!-- Emblem -->
        <brand-emblem class="contact-card__emblem" />
        <!-- Box -->
        <v-card class="contact-card__box black py-4 px-10" flat>
          <v-row class="contact-card__info" align="center" justify="space-between">
            <!-- Brand -->
            <v-col class="flex-grow-0 pl-6" cols="4" sm="1">
              <brand :typeface="false" />
            </v-col>
            <!-- Copy -->
            <v-col cols="12" sm="6" class="flex-grow-0">
              <p class="body-1 white--text">
                يسعد فريق سينسز بتواصلك، ويعتز باختيارك الأمثل له، ويضمن لك الجودة التي تبحث عنها.
              </p>
            </v-col>
            <!-- CTA -->
            <v-col cols="12" sm="5" class="flex-grow-0 d-flex justify-sm-end">
              <v-btn v-if="!isRoute('Contact')" :to="{ name: 'Contact' }" color="primary lighten-1" large outlined>
                <v-icon left v-text="'mdi-phone'" />تواصل معنا
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// components
import Brand from '@/components/ui/Brand'
import BrandEmblem from '@/components/ui/BrandEmblem'
import BrandLines from '@/components/ui/BrandLines'
// export
export default {
  // name
  name: 'ContactCard',
  // components
  components: {
    brand: Brand,
    'brand-emblem': BrandEmblem,
    'brand-lines': BrandLines
  },
  // data
  data() {
    return {
      element: null
    }
  },
  // mounted
  mounted() {
    // set element
    this.element = this.$el
  }
}
</script>

<style lang="scss">
.contact-card,
.contact-card__wrap {
  position: relative;
  overflow: hidden;
}
.contact-card__wrap {
  padding: 2px;
}

.contact-card__lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.contact-card__emblem {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
